import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general.ts'

import { ExcursionById, IExcursionsList } from '../list/model'

import { CalendarSearch, SearchCalendar, SearchDirection } from './model'

export const SearchExcursions = {
  searchDirection(search: string, abort?: AbortSignal) {
    return clientApi.get<Response<SearchDirection[]>>('/excursions/search', {
      params: { input_search: search },
      signal: abort,
    })
  },
  calendarDate(data: SearchCalendar) {
    return clientApi.post<Response<CalendarSearch[]>>(
      '/excursions/calendar',
      data,
    )
  },
  getSearchByDirection(searchId: string, abort?: AbortSignal) {
    return clientApi.post<Response<IExcursionsList[]>>(
      '/excursions/by_direction',
      { direction_id: searchId },
      {
        signal: abort,
      },
    )
  },
  calendarFromDate(id: string) {
    return clientApi.get<Response<ExcursionById[]>>(
      `/excursions/calendar/${id}`,
    )
  },
}
